import React, { ReactNode } from 'react';
import { useLanguageContext } from '@hooks/useLanguageContext';

export interface IMdFormatterProps {
  md: boolean;
}

export const MdFormatter = ({ md }: IMdFormatterProps): ReactNode => {
  const { dictionary } = useLanguageContext();

  return <span>{`${md ? dictionary.trials.table.mdTrue : dictionary.trials.table.mdFalse}`}</span>;
};
